/* esm.sh - rxjs@7.8.2/webSocket */
export * from "/*rxjs@7.8.2/esnext/webSocket.mjs";
